var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmWidthLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.778,
    height: 14.935,
    viewBox: "0 0 226.778 14.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8932",
    "data-name": "Group 8932",
    transform: "translate(-9.751 -686.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8961",
    "data-name": "Path 8961",
    d: "M-10693.1-15510.681h225.777",
    transform: "translate(10703.351 16204.873)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8963",
    "data-name": "Path 8963",
    d: "M-10693.1-15510.681h13.935",
    transform: "translate(-15274.652 11380.323) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8964",
    "data-name": "Path 8964",
    d: "M-10693.1-15510.681h13.935",
    transform: "translate(-15500.43 11380.323) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmWidthLine);
export default __webpack_public_path__ + "static/media/farmWidthLine.9ca92ab79531cdf2ae26e8e1f33bf827.svg";
export { ForwardRef as ReactComponent };